/** @jsxImportSource preact */
import { cleanQuantityText } from "../../cart/selection";
import * as copy from "../../paraglide/messages.js";
import { MinusIcon, PlusIcon } from "../icons";

export interface QuantityStepperProps {
  id: string;
  label: string;
  /** 数量框下的一行小字：Shopify 告诉过的上限、购物车里已有几件，或刚被改过数量的说明。 */
  hint: string;
  text: string;
  decreaseDisabled: boolean;
  increaseDisabled: boolean;
  /** 写入中整组不可改。 */
  disabled: boolean;
  onStep: (delta: 1 | -1) => void;
  onType: (text: string) => void;
  /** 离开数量框时把不合法或超出上限的数改回来。 */
  onSettle: () => void;
}

/** 数量：减号、可直接输入的数字框、加号；数字框里 ↑ ↓ 也能加减。 */
export function QuantityStepper({
  id,
  label,
  hint,
  text,
  decreaseDisabled,
  increaseDisabled,
  disabled,
  onStep,
  onType,
  onSettle,
}: QuantityStepperProps) {
  return (
    <div class="gn-cart-qty-row">
      <div class="gn-cart-qty-label">
        <label for={id}>{label}</label>
        <div class="gn-cart-sub" title={hint || undefined}>
          {hint}
        </div>
      </div>
      <div class="gn-cart-stepper">
        <button
          aria-label={copy.widget_cart_decrease()}
          class="gn-cart-step"
          disabled={disabled || decreaseDisabled}
          onClick={() => {
            onStep(-1);
          }}
          type="button"
        >
          <MinusIcon size={15} strokeWidth={2.2} />
        </button>
        <input
          autoComplete="off"
          class="gn-cart-qty"
          disabled={disabled}
          id={id}
          inputMode="numeric"
          onBlur={onSettle}
          onInput={(event) => {
            // 只收数字、最多三位；受控值没变时 Preact 不会重绘，所以直接把框里的字改回去。
            const typed = event.currentTarget.value;
            const clean = cleanQuantityText(typed);
            if (clean !== typed) event.currentTarget.value = clean;
            onType(clean);
          }}
          onKeyDown={(event) => {
            if (event.key !== "ArrowUp" && event.key !== "ArrowDown") return;
            event.preventDefault();
            const delta = event.key === "ArrowUp" ? 1 : -1;
            if (delta === 1 ? !increaseDisabled : !decreaseDisabled)
              onStep(delta);
          }}
          type="text"
          value={text}
        />
        <button
          aria-label={copy.widget_cart_increase()}
          class="gn-cart-step"
          disabled={disabled || increaseDisabled}
          onClick={() => {
            onStep(1);
          }}
          type="button"
        >
          <PlusIcon size={15} strokeWidth={2.2} />
        </button>
      </div>
    </div>
  );
}
